import { TemplatePage } from './types';

const pinterestPage: TemplatePage = {
  header: {
    color: '#F5ABAC',
    icon: 'images/video-templates/pinterest.jpg',
    title: 'Pinterest Video Templates Collection',
    title_meta: '100+ Easy-to-Edit Pinterest Video Templates',
    description_meta:
      'Create awe-inspiring video pins with Wave.video’s collection of easily customizable Pinterest video templates.',
    description:
      'Create awe-inspiring video pins with our collection of easily customizable Pinterest video templates. Skyrocket ' +
      'your brand’s growth on Pinterest using the power of video!'
  },
  footer: {
    category: 'Pinterest',
    description:
      'Making eye-catching and engaging videos for social media has never been more accessible with Wave.video’s ' +
      'collection of easy-to-customize Pinterest video templates. Just choose a template that suits your goals best, ' +
      'personalize it to match your brand, and download the final video to your computer, embed it on your website, or ' +
      'share it on social platforms. Easy and free!'
  },
  content: [
    {
      type: 'templates',
      title: 'Pinterest video templates',
      search: {
        name: 'pinterest'
      }
    },
    {
      type: 'stocks',
      title: 'pinterest',
      search: { name: 'pinterest' }
    },
    { type: 'calendar' }
  ]
};

export default pinterestPage;
